/**
 * Frågefältet säger till när någon skriver, så att ELvis kan "lyssna".
 * En fönsterhändelse i stället för delat tillstånd: ingen re-render av
 * chatten per tangenttryckning, och fältet behöver inte veta att maskoten finns.
 */
export const ELVIS_SKRIVER = 'elvis:anvandaren-skriver';

export function signaleraSkriver(): void {
  window.dispatchEvent(new Event(ELVIS_SKRIVER));
}
